import * as R from 'ramda/src/index';
import moment from 'moment';

const OB = 'OB';
const IB = 'IB';
const DEPARTURE = 'departure';
const ARRIVAL = 'arrival';
const MIN = 'min';
const MAX = 'max';

// const baggageDefaultOptions = [
//   {
//     name: 'included',
//     disabled: true
//   },
//   {
//     name: 'notIncluded',
//     disabled: true
//   },
//   {
//     name: 'all',
//     disabled: false
//   }
// ];

const getPriceTypeValue = (type) => R.pipe(
  R.pluck('minMetrics'),
  R.flatten,
  R.pluck('price'),
  R.apply(Math[type])
);

const getResultStopsValues = R.pipe(
  R.pluck('legs'),
  R.flatten,
  R.map(({stopsCount, totalPrices}) => ({count: stopsCount, prices: Math.min(...totalPrices)})),
  R.groupBy(R.prop('count')),
  R.values,
  R.map(
    R.reduce((acc, option) => {
      if (R.isEmpty(R.keys(acc)) || acc.prices > option.prices) {
        return option;
      }

      return acc;
    }, {})
  ),
  R.map((opt) => ({count: opt.count, price: opt.prices}))
);

const createAirlineOption = (results) => (airline) => ({
  name: airline.name,
  code: airline.code,
  price: R.pipe(
    R.filter(({airlines}) => R.includes(airline, airlines)),
    getPriceTypeValue('min')
  )(results)
});

const getAirlines = (results) =>
  R.pipe(
    R.pluck('airlines'),
    R.map(R.values),
    R.flatten,
    R.uniq,
    R.map(createAirlineOption(results))
  )(results);

// const createTransportType = (results) => (transportation) => ({
//   name: transportation,
//   price: R.pipe(
//     R.filter(({transportationTypes}) => R.includes(transportation, transportationTypes)),
//     getPriceTypeValue('min')
//   )(results)
// });

// const getTransportTypes = (results) => R.pipe(
//   R.pluck('transportationTypes'),
//   R.flatten,
//   R.uniq,
//   R.map(createTransportType(results))
// )(results);

const getProviders = (results) => R.pipe(
  R.pluck('providers'),
  R.flatten,
  R.pluck('provider'),
  R.uniqBy(R.prop('name')),
  R.map(createProviderOption(results))
)(results);

const createProviderOption = (results) => ({name, presentationName}) => ({
  name,
  presentationName,
  price: R.pipe(
    R.filter(({providers}) => R.any(R.pathEq(['provider', 'name'], name), providers)),
    R.pluck('providers'),
    R.flatten,
    R.filter(R.pathEq(['provider', 'name'], name)),
    R.pluck('total'),
    R.apply(Math.min)
  )(results)
});

// const getBaggageOptions = R.pipe(
//   R.pluck('legs'),
//   R.flatten,
//   R.pluck('segments'),
//   R.flatten,
//   R.pluck('services'),
//   R.pluck('baggageAllowance'),
//   R.map((val) => ({
//     name: val ? 'included' : 'notIncluded',
//     disabled: false
//   }))
// );

const getSegmentsByLegType = (legType) => R.pipe(
  R.pluck('legs'),
  R.map(legType === OB ? R.head : R.last),
  R.pluck('segments')
);

const getFlightTimesByLegTypeAndDestination = (legType, destination) => R.pipe(
  getSegmentsByLegType(legType),
  R.map(destination === DEPARTURE ? R.head : R.last),
  R.map(R.path(['route', destination, 'datetime']))
);

const getDurationsByLegType = (type) => R.pipe(
  R.pluck('legs'),
  R.map(type === OB ? R.head : R.last),
  R.pluck('duration')
);

const getTimestampFromTimes = (valueType, momentTimes) => {
  if (valueType === MIN) {
    return moment.min(...momentTimes).unix();
  }

  return moment.max(...momentTimes).unix();
};

export const updateFilterOptions = ({results}) => {
  const legsWithTotalPrices = results.map(({providers, legs}) => {
    const resultTotalPrices = R.pipe(
      R.flatten,
      R.pluck('total')
    )(providers);

    return {
      legs: legs.map(({stopsCount}) => ({
        totalPrices: resultTotalPrices,
        stopsCount
      }))
    };
  });
  const priceMaxValue = Math.ceil(Math.round(getPriceTypeValue(MAX)(results) * 100) / 100);
  const priceMinValue = Math.floor(Math.round(getPriceTypeValue(MIN)(results) * 100) / 100);
  const noOfStopsOptions = getResultStopsValues(legsWithTotalPrices);
  const maxStopsValue = Math.max(...R.pluck('count')(noOfStopsOptions));
  const airlines = getAirlines(results);
  const providers = getProviders(results);
  // const transportTypes = getTransportTypes(results);
  // const baggageApiOptions = getBaggageOptions(results);
  // const baggageOptions = baggageDefaultOptions.map(
  //   (defaultOption) => baggageApiOptions.find((option) => option.name === defaultOption.name) || defaultOption
  // );
  const obTimeDepartureMin = getTimestampFromTimes(MIN, getFlightTimesByLegTypeAndDestination(OB, DEPARTURE)(results));
  const obTimeDepartureMax = getTimestampFromTimes(MAX, getFlightTimesByLegTypeAndDestination(OB, DEPARTURE)(results));
  const obTimeArrivalMin = getTimestampFromTimes(MIN, getFlightTimesByLegTypeAndDestination(OB, ARRIVAL)(results));
  const obTimeArrivalMax = getTimestampFromTimes(MAX, getFlightTimesByLegTypeAndDestination(OB, ARRIVAL)(results));
  const obTimeDurationMin = Math.min(...getDurationsByLegType(OB)(results));
  const obTimeDurationMax = Math.max(...getDurationsByLegType(OB)(results));
  const ibTimeDepartureMin = getTimestampFromTimes(MIN, getFlightTimesByLegTypeAndDestination(IB, DEPARTURE)(results));
  const ibTimeDepartureMax = getTimestampFromTimes(MAX, getFlightTimesByLegTypeAndDestination(IB, DEPARTURE)(results));
  const ibTimeArrivalMin = getTimestampFromTimes(MIN, getFlightTimesByLegTypeAndDestination(IB, ARRIVAL)(results));
  const ibTimeArrivalMax = getTimestampFromTimes(MAX, getFlightTimesByLegTypeAndDestination(IB, ARRIVAL)(results));
  const ibTimeDurationMin = Math.min(...getDurationsByLegType(IB)(results));
  const ibTimeDurationMax = Math.max(...getDurationsByLegType(IB)(results));

  return {
    price: {
      min: priceMinValue,
      max: priceMaxValue
    },
    stops: {
      defaultValue: maxStopsValue,
      options: noOfStopsOptions
    },
    airlines: {
      options: airlines
    },
    providers: {
      options: providers
    },
    // baggages: {
    //   options: baggageOptions
    // },
    // transportTypes: {
    //   options: transportTypes
    // }
    obTimes: {
      departure: {
        min: obTimeDepartureMin,
        max: obTimeDepartureMax,
        value: [obTimeDepartureMin, obTimeDepartureMax]
      },
      arrival: {
        min: obTimeArrivalMin,
        max: obTimeArrivalMax,
        value: [obTimeArrivalMin, obTimeArrivalMax]
      },
      duration: {
        min: obTimeDurationMin,
        max: obTimeDurationMax,
        value: obTimeDurationMax
      }
    },
    ibTimes: {
      departure: {
        min: ibTimeDepartureMin,
        max: ibTimeDepartureMax,
        value: [ibTimeDepartureMin, ibTimeDepartureMax]
      },
      arrival: {
        min: ibTimeArrivalMin,
        max: ibTimeArrivalMax,
        value: [ibTimeArrivalMin, ibTimeArrivalMax]
      },
      duration: {
        min: ibTimeDurationMin,
        max: ibTimeDurationMax,
        value: ibTimeDurationMax
      }
    }
  };
};
